import { call, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { Urls } from 'src/common/urls';
import { getErrorFromResponse } from 'src/features/Security/networking/util';

const buildQueryString = (filters?: any): string => {
    if (!filters) {
        return ""
    }

    const params = Object.keys(filters)
        .filter(key => filters[key] !== undefined && filters[key] !== null && filters[key] !== "")
        .map(key => `${key}=${encodeURIComponent(filters[key])}`)

    return params.length > 0 ? `?${params.join("&")}` : ""
}

function* getQuotationFileApi(action: Actions.GetQuotationFileAction) {
    try {
        const body = {
            html: action.html
        }

        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.UTILS.HTML_TO_PDF, body, { responseType: "blob" })
        yield put(Actions.geQuotationFileApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getQuotationFileApiError(getErrorFromResponse(err)));
    }
}

function* upsertQuotationApi(action: Actions.UpsertQuotationAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.QUOTATION.UPSERT, action.quotation)
        yield put(Actions.upsertQuotationApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.upsertQuotationApiError(getErrorFromResponse(err)));
    }
}

function* getQuotationsApi(action: Actions.GetQuotationsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.QUOTATION.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getQuotationsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getQuotationsApiError(getErrorFromResponse(err)));
    }
}

function* getQuotationByIdApi(action: Actions.GetQuotationByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.QUOTATION.GET_BY_ID(action.quotationId))
        yield put(Actions.getQuotationByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getQuotationByIdApiError(getErrorFromResponse(err)));
    }
}

function* getQuotationTemplatesApi(action: Actions.GetQuotationTemplatesAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.QUOTATION.GET_TEMPLATES(action.activeOnly))
        yield put(Actions.getQuotationTemplatesApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getQuotationTemplatesApiError(getErrorFromResponse(err)));
    }
}

function* upsertQuotationTemplateApi(action: Actions.UpsertQuotationTemplateAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.QUOTATION.UPSERT_TEMPLATE, action.template)
        yield put(Actions.upsertQuotationTemplateApiSuccess(response.data))
        yield put(Actions.getQuotationTemplatesApi(false))
    } catch (err) {
        yield put(Actions.upsertQuotationTemplateApiError(getErrorFromResponse(err)));
    }
}

function* generateQuotationPdfApi(action: Actions.GenerateQuotationPdfAction) {
    try {
        const response = yield call(
            NetworkingProvider.getInstance().getControlInterface().post,
            Urls.BACKEND.QUOTATION.PDF(action.quotationId),
            action.request,
            { responseType: "blob" },
        )
        yield put(Actions.generateQuotationPdfApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.generateQuotationPdfApiError(getErrorFromResponse(err)));
    }
}

function* sendQuotationApi(action: Actions.SendQuotationAction) {
    try {
        const response = yield call(
            NetworkingProvider.getInstance().getControlInterface().post,
            Urls.BACKEND.QUOTATION.SEND_TELEGRAM(action.quotationId),
            action.request,
        )
        yield put(Actions.sendQuotationApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.sendQuotationApiError(getErrorFromResponse(err)));
    }
}

function* updateQuotationStatusApi(action: Actions.UpdateQuotationStatusAction) {
    try {
        const response = yield call(
            NetworkingProvider.getInstance().getControlInterface().post,
            Urls.BACKEND.QUOTATION.STATUS(action.quotationId),
            { status: action.status },
        )
        yield put(Actions.updateQuotationStatusApiSuccess(response.data))
        yield put(Actions.getQuotationsApi())
    } catch (err) {
        yield put(Actions.updateQuotationStatusApiError(getErrorFromResponse(err)));
    }
}

export default function* quotationSagas() {
    yield takeLatest(ActionTypes.GET_QUOTATION_FILE_API, getQuotationFileApi)
    yield takeLatest(ActionTypes.UPSERT_QUOTATION_API, upsertQuotationApi)
    yield takeLatest(ActionTypes.GET_QUOTATIONS_API, getQuotationsApi)
    yield takeLatest(ActionTypes.GET_QUOTATION_BY_ID_API, getQuotationByIdApi)
    yield takeLatest(ActionTypes.GET_QUOTATION_TEMPLATES_API, getQuotationTemplatesApi)
    yield takeLatest(ActionTypes.UPSERT_QUOTATION_TEMPLATE_API, upsertQuotationTemplateApi)
    yield takeLatest(ActionTypes.GENERATE_QUOTATION_PDF_API, generateQuotationPdfApi)
    yield takeLatest(ActionTypes.SEND_QUOTATION_API, sendQuotationApi)
    yield takeLatest(ActionTypes.UPDATE_QUOTATION_STATUS_API, updateQuotationStatusApi)
}
